import type { ProductComparison } from '../api/types';

interface ShopNameProps {
  product: Pick<ProductComparison, 'cheapestShop' | 'position'>;
}

/**
 * When nobody else lists the product, the cheapest shop on Heureka is our own.
 * Saying so beside the name stops the column from reading as a competitor.
 */
export function ShopName({ product }: ShopNameProps) {
  if (product.cheapestShop === null) {
    return <>—</>;
  }

  return (
    <>
      {product.cheapestShop}
      {product.position === 'soleSeller' && <span className="muted"> (you)</span>}
    </>
  );
}
